import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 589.796 590.816"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#FFF" }, [
      _createElementVNode("path", { d: "m228.257 150.92 220.31 127.195c13.068 7.545 13.068 26.409 0 33.954l-220.31 127.195c-13.069 7.546-29.405-1.886-29.405-16.977v-254.39c0-15.09 16.336-24.522 29.405-16.977" }),
      _createElementVNode("path", { d: "M294.031 5.817C134.524 5.817 4.756 135.585 4.756 295.092s129.768 289.276 289.275 289.276 289.276-129.77 289.276-289.276C583.308 135.585 453.538 5.817 294.031 5.817m.001 529.543c-132.696 0-240.268-107.571-240.268-240.267S161.335 54.825 294.032 54.825c132.696 0 240.267 107.571 240.267 240.268 0 132.696-107.571 240.267-240.267 240.267" })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "play-button"}) } }